export default {
  "fontElementMap": "ZYUuj",
  "quote": "VKix0"
};